import React, { useEffect, useState } from 'react';
import { Globe } from 'lucide-react';

const LANGUAGES = [
    { code: 'it', name: 'Italiano' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'es', name: 'Español' },
    { code: 'de', name: 'Deutsch' }
];

const TranslateButton = ({ className = '' }) => {
    const [currentLang, setCurrentLang] = useState('it');

    useEffect(() => {
        const updateFromStorageOrCookie = () => {
            // 1. Controlliamo prima la preferenza manuale salvata
            const manual = localStorage.getItem('craftonline_manual_lang');
            if (manual) {
                setCurrentLang(manual);
                return;
            }

            // 2. In alternativa, leggiamo il cookie di Google
            const match = document.cookie.match(/googtrans=\/[^\/]+\/([^\s;]+)/);
            if (match && match[1]) {
                setCurrentLang(match[1]);
            } else {
                setCurrentLang('it');
            }
        };

        updateFromStorageOrCookie();

        // Listener per eventi custom (sincronizzazione globale)
        const handleLanguageEvent = (e) => {
            if (e.detail) setCurrentLang(e.detail);
        };

        window.addEventListener('craftonline-language-set', handleLanguageEvent);

        return () => {
            window.removeEventListener('craftonline-language-set', handleLanguageEvent);
        };
    }, []);

    const handleLanguageChange = (e) => {
        const selectedLang = e.target.value;
        setCurrentLang(selectedLang);

        // Salviamo la preferenza per il componente Init
        localStorage.setItem('craftonline_manual_lang', selectedLang);

        if (selectedLang === 'it') {
            // --- LOGICA DI RESET TOTALE (RITORNO A ITALIANO) ---
            const domain = window.location.hostname;
            const domainParts = domain.split('.');
            const baseDomain = domainParts.length > 1 ? `.${domainParts.slice(-2).join('.')}` : domain;
            const domains = [domain, `.${domain}`, baseDomain, ''];
            const paths = ['/', window.location.pathname];

            // Rimuoviamo il cookie googtrans con la logica rafforzata
            domains.forEach(d => {
                paths.forEach(p => {
                    const domainStr = d ? `; domain=${d}` : '';
                    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${p}${domainStr}`;
                });
            });

            // Pulizia local/session storage di Google
            try {
                sessionStorage.removeItem('googtrans');
                Object.keys(localStorage).forEach(key => {
                    if (key.includes('goog')) localStorage.removeItem(key);
                });
            } catch (err) { console.error("Storage clean error:", err); }

            // Reset classi CSS sul tag HTML
            document.documentElement.classList.remove('translated-ltr', 'translated-rtl');

            // Ricarichiamo per pulire lo stato dello script di Google
            window.location.reload();
        } else {
            // --- LOGICA DI TRADUZIONE ---
            document.cookie = `googtrans=/it/${selectedLang}; path=/`;
            document.cookie = `googtrans=/it/${selectedLang}; path=/; domain=${window.location.hostname}`;

            // Se il widget di Google è già pronto (es. cambio da EN a FR), usiamo la sua select interna
            const googleSelect = document.querySelector('.goog-te-combo');
            if (googleSelect) {
                googleSelect.value = selectedLang;
                googleSelect.dispatchEvent(new Event('change'));
            } else {
                // Altrimenti (es. cambio da IT a EN), ricarichiamo: al prossimo avvio GoogleTranslateInit leggerà il nuovo cookie e inietterà lo script
                window.location.reload();
            }
        }
    };

    return (
        <div className={`relative flex items-center gap-2 ${className}`}>
            <Globe size={18} className="text-craft-red" />
            <div className="relative">
                <select
                    value={currentLang}
                    onChange={handleLanguageChange}
                    className="appearance-none bg-white text-craft-dark font-hand text-lg pr-10 pl-4 py-1.5 stitched-border cursor-pointer outline-none hover:bg-red-50 focus:ring-2 focus:ring-craft-red/30 transition-all"
                    title="Scegli la lingua / Choose language"
                >
                    {LANGUAGES.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                            {lang.name}
                        </option>
                    ))}
                </select>
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-craft-red text-[10px]">
                    ▼
                </div>
            </div>
        </div>
    );
};

export default TranslateButton;